import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form } from 'antd';
import { ReferralCodeFormFields, toPayload, type ReferralCodeFormValues } from './form-fields';

export const ReferralCodeCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'referral-codes',
    redirect: 'list',
  });

  return (
    <Create resource="referral-codes" title="Create Referral Code" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values) => formProps.onFinish?.(toPayload(values as ReferralCodeFormValues))}
      >
        <ReferralCodeFormFields />
      </Form>
    </Create>
  );
};
